import React from 'react'

function OrderInfo({keyText, value}) {
  return (
    <div className="flex items-center justify-between py-2  text-left">
        <div className="w-1/2 text-gray-500 text-sm font-medium capitalize">
            {keyText}:
        </div>
        <div className="w-1/2 text-gray-800 text-sm">
            {value}
        </div>
    </div>

  )
}

export default OrderInfo